// extracted by mini-css-extract-plugin
export default {"highlight":"AnswersV2_highlight__3U6Dr"};